<!-- Defines the set of hashes being watched for -->

<template>
  <AppModalPreRegister />
  <AppModalMaintenance />
  <AppModalMailingList />
  <AppModalSignIn />
  <AppModalProfile />
  <AppModalCropImage />
  <AppModalCropPortrait />
  <AppModalEmailChange />
  <AppModalInPersonClosed />
  <AppModalContactAttendee />
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import AppModalPreRegister from "@/components/App/Modal/PreRegister";
import AppModalMaintenance from "@/components/App/Modal/Maintenance";
import AppModalSignIn from "@/components/App/Modal/SignIn";
import AppModalProfile from "@/components/App/Modal/Profile";
import AppModalCropImage from "@/components/App/Modal/CropImage";
import AppModalCropPortrait from "@/components/App/Modal/CropPortrait";
import AppModalEmailChange from "@/components/App/Modal/EmailChange";
import AppModalMailingList from "@/components/App/Modal/MailingList";
import AppModalInPersonClosed from "@/components/App/Modal/InPersonClosed";
import AppModalContactAttendee from "@/components/App/Modal/ContactAttendee";
</script>
